// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/dialogs/download-onetime-pmt-report/download-onetime-pmt-report.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;AADF","sourcesContent":["@import (reference) url('../../../../styles.less');\n@import (reference) url('../../../../assets/ngb-modals.less');\nmat-slide-toggle {\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
